/*
 * @Descripttion:
 * @Author: wyx
 * @Date: 2020-09-11 16:29:38
 * @LastEditors: wyx
 * @LastEditTime: 2020-09-21 15:40:42
 */
import axios from "@/server/request";
export default class api {
    //登录
    static login(params) {
        return axios.post({
            url: "/indexjy/login",
            params
        });
    }

    //注册
    static register(params) {
        return axios.post({
            url: "/indexjy/register",
            params
        });
    }

    //申请
    static apply(params) {
        return axios.post({
            url: "/indexjy/apply",
            params
        });
    }

    //发送验证码
    static sendCode(params) {
        return axios.post({
            url: "/indexjy/sendCode",
            params
        });
    }

    //修改密码
    static editPass(params) {
        return axios.post({
            url: "/user/editPass",
            params
        });
    }

    //忘记密码
    static forget(params) {
        return axios.post({
            url: "/indexjy/forget",
            params
        });
    }

    //订单详情
    static log(params) {
        return axios.post({
            url: "/pay/log",
            params
        });
    }
    //价格列表
    static getDcVipLevel(params) {
        return axios.post({
            url: "/user/vipLevel",
            params
        });
    }

    //立即购买
    static getDcBuy(params) {
        return axios.post({
            url: "/pay/buy",
            params
        });
    }

    //查询订单
    static getDcQuery(params) {
        return axios.post({
            url: "/pay/query",
            params
        });
    }

    //头像
    static editAvatar(params) {
        return axios.post({
            url: "/user/editAvatar",
            params
        });
    }
    
}
